module.exports = new __parcel__URL__("logo_cerema.edb3eafb.jpg").toString();